import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { ContentHeader, ContentBody } from 'areas/shared/components';
import FileUploadDemo from './FileUploadDemo';

const FileUploads = () => (
	<React.Fragment>
		<ContentHeader title="FileUploads" description="Fileupload control">
		</ContentHeader>
		<ContentBody>
			<Row>
				<Col md={12}>
					<FileUploadDemo />
				</Col>
			</Row>
		</ContentBody>
	</React.Fragment>
)

export default FileUploads;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/FileUploads/index.js